var _path, _line, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 92,
    viewBox: "0 0 20 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2147 2.75421C12.2147 1.48465 11.1855 0.455475 9.91592 0.455475C8.64636 0.455475 7.61719 1.48465 7.61719 2.75421V3.95192C7.61719 5.8806 6.05368 7.44411 4.125 7.44411H2.93154C1.66199 7.44411 0.632812 8.47328 0.632812 9.74284C0.632812 11.0124 1.66199 12.0416 2.93154 12.0416H4.125C6.05368 12.0416 7.61719 13.6051 7.61719 15.5338V16.7306C7.61719 18.0002 8.64636 19.0294 9.91592 19.0294C11.1855 19.0294 12.2147 18.0002 12.2147 16.7306V15.5355C12.2147 13.6058 13.7789 12.0416 15.7086 12.0416H16.908C18.1775 12.0416 19.2067 11.0124 19.2067 9.74284C19.2067 8.47328 18.1775 7.44411 16.908 7.44411L15.709 7.44411C13.7791 7.44411 12.2147 5.87965 12.2147 3.94979V2.75421Z",
    fill: "#F69A4D"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.5667,
    y1: 24.0294,
    x2: 10.5667,
    y2: 91.4934,
    stroke: "url(#paint0_linear_340_4129)",
    strokeWidth: 1.29739
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_340_4129",
    x1: 8.91782,
    y1: 25.7096,
    x2: 8.91781,
    y2: 92.6134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/listIcon.1e3c08d145198f08e46ce143fd85de54.svg";
export { ForwardRef as ReactComponent };